export const classes = {
  priceRow: 'flex items-end gap-[9px]',
  price:
    'text-[38px] font-extrabold leading-none tracking-[-0.03em] text-taupe-3 dark:text-mauve-1',
  priceNote: 'pb-[5px] text-[13px] text-taupe-1 dark:text-mauve-3',
  quantityRow:
    'place-between mt-5 rounded-[14px] border border-hair bg-black/[0.04] px-3 py-2.5 dark:border-hair-dark dark:bg-white/[0.07]',
  quantityLabel: 'text-[13px] font-semibold text-taupe-2 dark:text-mauve-2',
  totals: 'mt-[18px]',
  consent: 'mt-[18px]',
  cta: 'mt-4 w-full',
  stripe: 'mt-[14px]',
};
